import React from 'react';
import { Link } from 'react-router-dom';
import UserProfilePic from '../common/UserProfilePic';

const ProfileSection = ({ user, setShowLogoutConfirm, activeItem, isMobile = false }) => {
  return (
    <>
      {/* Profile direct link */}
      <Link
        to="/dashboard/listings"
        className="rounded-full text-gray-600 hover:text-brand-teal"
      >
        <UserProfilePic user={user} className="w-8 h-8" altText={user?.username || 'User profile'} />
      </Link>

      {/* Logout button — desktop only */}
      {!isMobile && (
        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="p-2 rounded-full text-gray-500 hover:text-brand-teal hover:bg-gray-100 transition-colors duration-200"
          aria-label="Logout"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
        </button>
      )}
    </>
  );
};

export default ProfileSection;